import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

interface IErrorModalProps {
    open: boolean;
    onClose: () => void;
    title: string,
    message: string
}

const ErrorModal = ({
    open,
    onClose,
    title,
    message
}: IErrorModalProps) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText>{message}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary" variant="contained">
                    Got it!
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ErrorModal;